<div class="content-with-stepper-and-title">
    <main class="field col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
        <h2 class="title offset-inline" id="generalTitle">
            {{copyService.copies.advisor_code_title}}
        </h2>
        <h3 class="sub-title offset-inline mt-3" id="subgeneralTitle">
            {{copyService.copies.advisor_code_sub1}}
        </h3>
        <br>
        <div class="content mt-4">
            <voxel-radio-button-group id="isAdvCode" class="radio-margin">
                <voxel-radio-button *ngFor="let selectionList of listAdvisor; let i=index; " [id]="'radioButtonID' + selectionList.label" radioName="adv_code" [checked]="this.channelCommunicatorService.getChannelId()==chanelid && i==0 || selectionList.checked" (change)="selectAdvisorCode($event)" [disabled] ="this.channelCommunicatorService.getChannelId() === chanelid && i==1" [value]="selectionList.value">{{selectionList.label}}</voxel-radio-button>
            </voxel-radio-button-group>
        </div>
        <footer>
            <form class="form row" id="codeAdvisorForm" [formGroup]="formGroup">
                <div *ngIf="this.channelCommunicatorService.getChannelId()==chanelid? true:advisorCodeInput" class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-3">
                    <vcl-form-field [label]="copyService.copies.code_advisor_selection" [msgErr]="copyService.copies.code_advisor_selection_error">
                        <input vclInput id="inputValueCodeAdvisor" type="text" ng-pattern="/^[a-zA-Z ]*$´+/" [maxlength]='18' [placeholder]="copyService.copies.code_advisor_selection_placeholder" (input)="reactiveInputChangeCode($event)" formControlName="codeAdvisor" [value]="vendorCodeNumber" onkeydown="return ( 
                            event.ctrlKey || event.altKey 
                        || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) 
                        || (95<event.keyCode && event.keyCode<106)
                        || (event.keyCode==8) || (event.keyCode==9) 
                        || (event.keyCode>34 && event.keyCode<40) 
                        || (event.keyCode==46)
                        || (event.keyCode==189) )">
                    </vcl-form-field>
                </div>
            </form>
        </footer>
        <div *ngIf="showWarning" class="div-warning">
            <vcl-alert 
                class="alert"
                [type]="'warning'"
                [light]="true"
                [icon]="error">
                {{ copyService.copies.advisor_code_warning }}
            </vcl-alert>
        </div>
        <div class="space"></div>
        <app-controls [nextLabel]="copyService.copies.advisor_code_button" [hasPrevious]="true" [nextDisabled]="isBtnDisabled" (only_previous)="sendBackButtonEvent()" (next)="next()"></app-controls>
    </main>
</div>